import { format, parseISO } from 'date-fns';

/** Format ISO date string as "yyyy-MM-dd HH:mm"; missing → null so InfoField renders N/A */
export const formatDateTime = (dateString: string | null | undefined): string | null => {
  if (!dateString || dateString === 'None') return null;
  try {
    return format(parseISO(dateString), 'yyyy-MM-dd HH:mm');
  } catch {
    return dateString;
  }
};

/** Format ISO date string as "yyyy-MM-dd"; missing → null so InfoField renders N/A */
export const formatDateOnly = (dateString: string | null | undefined): string | null => {
  if (!dateString || dateString === 'None') return null;
  try {
    return format(parseISO(dateString), 'yyyy-MM-dd');
  } catch {
    return dateString;
  }
};
